// extracted by mini-css-extract-plugin
export default {"defaultMessage":"ViewLayout_defaultMessage__LhTYa","addViewBtnText":"ViewLayout_addViewBtnText__G9SGK","disclaimer-text":"ViewLayout_disclaimer-text__Tgn-j"};